<template>
	<div class="empty">
		<div class="content">
			<div class="empty-img">
				<img :src="NoData" alt="">
			</div>
			<div class="empty-text">
				内容已下架或者不存在
			</div>
		</div>
	</div>
</template>
<script>
import NoData from "@/assets/image/learning/no_data.png";
export default {
	data() {
		return {
			NoData: NoData
		};
	}
};
</script>
<style scoped lang="css">
.empty{
	display: flex;
	flex-direction: column;
	min-height: 100%;
}
.content{
	flex: 1;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
}
.empty-img img{
	width: 114px;
	height: 114px;
}
.empty-text{
	font-weight: 400;
	font-size: 13px;
	color: #C0C4CC;
	margin-top: 6px;
}
</style>